import type { FC } from 'react';

interface LogoProps {
  height?: number | string;
  width?: number | string;
  src?: string;
}

const Logo: FC<LogoProps> = ({ width, height, src }: LogoProps) => {
  let logoSrc = src;
  // fallback to localStorage
  if (!logoSrc) {
    try {
      const whiteLabel: any = JSON.parse(localStorage.getItem('white_label') || '{}');
      if (whiteLabel?.logo?.length > 0) {
        logoSrc = whiteLabel.logo;
      } else {
        logoSrc = '/static/logo.png'; // default fallback
      }
    } catch (error) {
      logoSrc = '/static/logo.png';
    }
  }

  return (
    <img
      width={width}
      height={height}
      style={{ objectFit: 'contain', maxHeight: '110px' }}
      src={logoSrc}
      alt="Logo"
    />
  );
};

export default Logo;
